import React from "react";

const HERO_TONES = {
  blue: {
    shell: "bg-[#F0F7FF] ring-[#007BFF]/10",
    label: "text-[#007BFF]/70",
    amount: "text-[#007BFF]",
  },
  amber: {
    shell: "bg-[#FFF8EF] ring-amber-200/60",
    label: "text-amber-700/70",
    amount: "text-amber-700",
  },
  violet: {
    shell: "bg-violet-50 ring-violet-200/70",
    label: "text-violet-700/70",
    amount: "text-violet-800",
  },
};

export function SetupCardSavedBody({
  heroLabel,
  heroAmount = "",
  primaryValue = "",
  primaryMeta = "",
  taxRows = [],
  taxRowsInline = false,
  metaLine = "",
  note = "",
  tone = "blue",
}) {
  const colors = HERO_TONES[tone] || HERO_TONES.blue;
  const useStructuredLayout = Boolean(primaryValue || taxRows.length);

  return (
    <div className="flex flex-col gap-2.5">
      <div className={`rounded-lg px-3 py-2.5 ring-1 ${colors.shell}`}>
        <p
          className={`mb-0 text-[9px] font-semibold uppercase tracking-wide ${colors.label}`}
        >
          {heroLabel}
        </p>

        {useStructuredLayout ? (
          <>
            <p
              className={`mb-0 mt-0.5 text-[26px] font-bold leading-tight tabular-nums ${colors.amount}`}
            >
              {primaryValue || "—"}
            </p>
            {primaryMeta ? (
              <p className="mb-0 mt-1 text-[13px] font-semibold text-slate-600">
                {primaryMeta}
              </p>
            ) : null}
            {taxRows.length ? (
              <div
                className={`mt-3 border-t pt-3 ${
                  taxRowsInline
                    ? "grid grid-cols-1 gap-3 sm:grid-cols-2"
                    : "space-y-3"
                } ${
                  tone === "amber"
                    ? "border-amber-200/80"
                    : tone === "violet"
                      ? "border-violet-200/80"
                      : "border-[#007BFF]/15"
                }`}
              >
                {taxRows.map((row) => (
                  <div key={row.label}>
                    <p className="mb-0 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
                      {row.label}
                    </p>
                    <p
                      className={`mb-0 mt-0.5 text-[22px] font-bold leading-tight tabular-nums ${colors.amount}`}
                    >
                      {row.value}
                    </p>
                  </div>
                ))}
              </div>
            ) : null}
          </>
        ) : (
          <>
            <p
              className={`mb-0 mt-0.5 text-[22px] font-bold leading-tight tabular-nums ${colors.amount}`}
            >
              {heroAmount || "—"}
            </p>
            {metaLine ? (
              <p className="mb-0 mt-1.5 text-[15px] font-semibold leading-snug text-slate-700">
                {metaLine}
              </p>
            ) : null}
          </>
        )}
      </div>
      {note ? (
        <p className="mb-0 text-[11px] leading-relaxed text-slate-500">{note}</p>
      ) : null}
    </div>
  );
}

export default SetupCardSavedBody;
